module.exports = __webpack_public_path__ + "static/favicon-7e561e0583ae8d40989c834e3ccf91ac.png";